export default __webpack_public_path__ + "static/media/Body shaming.06263f19.png";